import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoMeritoDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoMeritoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoMeritoService(): Observable<BodyListResponse<CatalogoMeritoDTO>> {
    return this.http.get<BodyListResponse<CatalogoMeritoDTO>>(API_URL + '/api/v1/catalogoMerito/todos');
  }

  guardarCatalogoMeritoService(catalogoMeritoDTO: CatalogoMeritoDTO): Observable<CatalogoMeritoDTO> {
    return this.http.post<CatalogoMeritoDTO>(API_URL + '/api/v1/catalogoMerito', catalogoMeritoDTO);
  }

  getCatalogoMeritoPorCodigoCatalogoMeritosService(codigoCatalogoMeritos: string): Observable<BodyResponse<CatalogoMeritoDTO>> {
    return this.http.get<BodyResponse<CatalogoMeritoDTO>>(API_URL + '/api/v1/catalogoMerito/' + codigoCatalogoMeritos);
  }
}
